const preferredTitleText = 'Meil on Sulle midagi öelda. Ja see on päris tähtis.';
const preferredTextHtml = '<strong>See veebilehekülg kasutab küpsiseid. Need on hädavajalikud, et Sinu kasutajakogemus oleks võimalikult sujuv ja meeldiv. Jätkates selle veebilehe sirvimist, võtame seda kui nõustumist meie küpsiste kasutamise põhimõtetega.</strong>';

const replacementFunction = () => {
    document.getElementById('cc-nb-title').innerText = preferredTitleText;
    document.getElementById('cc-nb-text').innerHTML = preferredTextHtml;
};

document.addEventListener('cc_noticeBannerShown', () => {
    console.log('cc_noticeBannerShown');

    replacementFunction();

    setTimeout(replacementFunction, 0);
    setTimeout(replacementFunction, 10);
    setTimeout(replacementFunction, 100);
    setTimeout(replacementFunction, 500);
    setTimeout(replacementFunction, 1000);

    // const $text = $('.freeprivacypolicy-com---nb-interstitial-overlay #cc-nb-text');
    //
    // while ($text.html() !== preferredHtml) {
    //     $text.html(preferredHtml);
    //
    //     console.log('replacing');
    // }
});
